import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PrintFileService {
    /**
     * Prints a Blob file.
     *
     * @param file The Blob file to be printed.
     * @param querySelector A valid selector for the DOM element where the iframe will be appended.
     *                        Note: The querySelector must be a valid selector for an element present in the DOM.
     */
    printBlobFile(file: Blob, querySelector: string) {
        const url = URL.createObjectURL(file);
        this.printFileFromUrl(url, querySelector);
    }

    /**
     * Prints a file from a specified URL. The method prints a file from a specified URL.
     * IFrame is utilized for printing.
     *
     *
     * @param url The URL of the file to be printed.
     * @param querySelector A valid selector for the DOM element where the iframe will be appended.
     *                        Note: The querySelector must be a valid selector for an element present in the DOM.
     */
    printFileFromUrl(url: string, querySelector: string) {
        const iframe = document.createElement('iframe');
        iframe.onload = () => iframe.contentWindow?.print();
        iframe.style.display = 'none';
        iframe.src = url;

        document.querySelector(querySelector)!.appendChild(iframe);
    }
}
